import { useMutation } from "@tanstack/react-query";

import { privateApi } from "@/api/axios";
import { errorToast } from "@/components/toast/error-toast";
import { useToastStore } from "@/components/toast/toast-store";
import type { ChangePasswordRequest } from "@/domains/profile/models/types";

export const useChangePassword = () => {
  const pushToast = useToastStore((state) => {
    return state.pushToast;
  });

  return useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      void pushToast({
        type: "success",
        title: "Your password has been successfully changed!",
      });
    },
    onError: (err) => {
      errorToast(err);
    },
  });
};

const changePassword = async (payload: ChangePasswordRequest) => {
  await privateApi.post("/password/change", payload);
};
